/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var _ = require('underscore');
var supportedGroups = {
    VISA: 'CREDIT_CARD',
    MASTERCARD: 'CREDIT_CARD',
    DISCOVER: 'CREDIT_CARD',
    DINERS: 'CREDIT_CARD',
    UNIONPAY: 'CREDIT_CARD',
    JCB: 'CREDIT_CARD',
    AMEX: 'CREDIT_CARD',
};
/**
 * Group networks by supportedGroup if the group has many networks
 * or by code in other case
 * @param {object} networks
 * @return {object} final grouped networks
 */
function group(networks) {
    var finalGroupedNetworks = {};

    _.each(firstGroup(networks), function (groupedNetwork, key) {
        if (groupedNetwork.length === 1) {
            finalGroupedNetworks[groupedNetwork[0].code] = groupedNetwork;
        } else {
            finalGroupedNetworks[key] = groupedNetwork;
        }
    });

    return finalGroupedNetworks;
}
/**
 * Take list of network and group them by supported group if found or by code if not
 * @param {object} networks
 * @return {object} grouped network
 */
function firstGroup(networks) {
    return _.groupBy(networks, function (aNetwork) {
        return supportedGroups[aNetwork.code] ? supportedGroups[aNetwork.code] : aNetwork.code;
    });
}
/**
 * return group if found in supportedGroups and used to group the networks
 * @param {string} code
 * @param {object} networks
 * @return {object} string if found and null if not
 */
function getGroup(code, networks) {
    return supportedGroups[code] && networks[supportedGroups[code]] ? supportedGroups[code] : null;
}

function containsAll(list1, list2) {
    return _.every(list2, function (code) {
        return _.contains(list1, code);
    });
}

function canBeGrouped(codes) {
    return containsAll(_.allKeys(supportedGroups), codes);
}
module.exports = {
    group: group,
    getGroup: getGroup,
    canBeGrouped: canBeGrouped,
};
